"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
const match_status_1 = require("../match-status");
class PaymentMethod extends MapperBuilder_1.default {
    constructor() {
        super();
        this.setStatus({
            BOLETO: 'boleto',
            PIX: 'pix',
            CREDIT_CARD: 'credit_card',
            TRANSFER: 'transfer',
            CASH: 'money',
            OTHERS: 'others',
        });
        this.setTranslations({
            [this.statusList.BOLETO]: 'Boleto Moben',
            [this.statusList.PIX]: 'PIX Moben',
            [this.statusList.CREDIT_CARD]: 'Cartão de crédito',
            [this.statusList.TRANSFER]: 'Transferência bancária',
            [this.statusList.CASH]: 'Dinheiro',
            [this.statusList.OTHERS]: 'Negociado com Inquilino',
        });
        this.setAssertions({
            isBoleto: this.buildAssertFunc(this.statusList.BOLETO),
            isPix: this.buildAssertFunc(this.statusList.PIX),
            isManaged: (status) => (match_status_1.default(status, this.statusList.BOLETO) || match_status_1.default(status, this.statusList.PIX)),
            isCreditCard: this.buildAssertFunc(this.statusList.CREDIT_CARD),
            isTransfer: this.buildAssertFunc(this.statusList.TRANSFER),
            isCash: (status) => (match_status_1.default(status, this.statusList.CASH) || match_status_1.default(status, 'cash')),
            isOther: this.buildAssertFunc(this.statusList.OTHERS),
        });
    }
}
exports.default = PaymentMethod;
//# sourceMappingURL=PaymentMethod.js.map